import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { MysqlProductsEdge, MysqlRanksEdge } from '../../graphqlTypes'

const Container = styled.ul`
  display: flex;
  list-style: none;
  overflow-x: scroll;
  padding: 16px 0 0 16px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 35px 0 0;
    padding: 0;
  }
`

const Item = styled.li`
  background: ${({ theme }) => theme.palette.background.main};
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  border-radius: 5px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  margin: 0 12px 0 0;
  padding: 8px;
  position: relative;
  width: 116px;
  &:last-child {
    margin: 0;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 100%;
      width: 16px;
      height: 100%;
    }
  }
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    border: 0;
    box-shadow: none;
    margin: 0 7px 0 0;
    padding: 7px;
    width: 165px;
  }
`

const ProductLink = styled(Link)`
  display: block;
  text-decoration: none;
`

const EmblemImage = styled.img`
  width: 24px;
  height: 24px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    width: 34px;
    height: 34px;
  }
`

const Image = styled.img`
  display: block;
  object-fit: contain;
  width: 100px;
  height: 100px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    width: 113px;
    height: 113px;
  }
`

const Text = styled.div`
  color: ${({ theme }) => theme.palette.font.main};
  font-size: 10px;
  font-weight: bold;
  margin: 8px 0 0;
`

const Manufacturer = styled.p`
  margin: 0 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    font-size: 12px;
  }
`

const Name = styled.p`
  font-size: 12px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    font-size: 14px;
  }
`

export default function ProductList({
  products,
  ranksEachCategory,
}: {
  products: MysqlProductsEdge[]
  ranksEachCategory: MysqlRanksEdge[]
}) {
  return (
    <Container>
      {products.map((product) => {
        const rank = ranksEachCategory.find(({ node }) => node.products!.mysqlId === product.node.mysqlId)
        const emblemUrl =
          rank!.node.rank === 1 ? product.node.fields!.grandAwardImageUrl : product.node.fields!.emblemImageUrl

        return (
          <Item key={product.node.id}>
            <ProductLink to={product.node.fields!.pagePath!}>
              <LazyLoadComponent>
                <EmblemImage alt={`ママリ口コミ大賞 エンブレム画像`} src={`${emblemUrl}?auto=format&w=68&h=68`} />
              </LazyLoadComponent>
              <LazyLoadComponent>
                <Image
                  alt={product.node.name!}
                  src={`${product.node.fields!.imageUrl}?auto=format&max-w=165px&max-h=165`}
                />
              </LazyLoadComponent>
              <Text>
                {product.node.manufacturer && <Manufacturer>{product.node.manufacturer}</Manufacturer>}
                <Name>{product.node.name}</Name>
              </Text>
            </ProductLink>
          </Item>
        )
      })}
    </Container>
  )
}
